
import {
  defineComponent,
  ref,
  computed,
  PropType,
} from 'vue';

import { useCreatedDevAccount } from '../composables/index';

import { GetV1AccountInfoApiResItem } from '@/api/manage-app/account-info/index.d';

export default defineComponent({
  name: 'CreatedDevAccount',
  emits: ['update:visible', 'handleSearch'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    accountItem: {
      type: Object as PropType<GetV1AccountInfoApiResItem>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const disabledVisible = computed({
      get() {
        return props.visible;
      },
      set(val: boolean) {
        emit('update:visible', val);
      },
    });
    const formData = ref({
      remark: '', // 备注
    });

    const {
      handleDisClose,
      handleDisSave,
    } = useCreatedDevAccount(
      formData,
      emit as any,
    );

    return {
      formData,
      disabledVisible,
      rules: {
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' },
        ],
      },
      handleDisClose,
      handleDisSave,
    };
  },
});
